export default __webpack_public_path__ + "static/media/1.ead578d7.png";